<template>
    <div class="premium-lock">
        <!-- Modal de upgrade -->
        <v-dialog v-model="showModal" max-width="500" content-class="premium-modal">
            <v-card class="premium-card">
                <!-- Header com gradiente -->
                <div class="premium-header">
                    <div class="crown-icon">{{ icon }}</div>
                    <h2 class="premium-title">{{ modal.title }}</h2>
                    <p class="premium-subtitle">{{ modal.subtitle }}</p>
                </div>

                <v-card-text class="premium-content pt-3">
                    <div class="features-container">
                        <div v-if="msg">
                            <p>{{ msg }}</p>
                        </div>
                        <template v-else>
                            <div
                                v-for="(feature, index) in modal.features" 
                                :key="index"
                                class="feature-item"
                            >
                                <v-icon color="success" class="feature-icon">check_circle</v-icon>
                                <span class="feature-text">{{ feature }}</span>
                            </div>
                        </template>
                    </div>
                   

                    <!-- Botão principal -->
                    <v-btn 
                        class="upgrade-button"
                        large 
                        block 
                        @click="handleUpgrade"
                        dark
                    >
                        <v-icon left>rocket</v-icon>
                        {{ modal.buttonText }}
                        <v-icon right>arrow_forward</v-icon>
                    </v-btn>

                    <!-- Garantia -->
                    <div class="guarantee mt-3">
                        <v-icon color="grey" small>security</v-icon>
                        <span class="guarantee-text">{{ testeGratisMsg }} *</span>
                    </div>
                </v-card-text>

                <v-card-actions class="premium-actions">
                    <v-btn
                        class="close-button"
                        text
                        @click="showModal = false"
                    >
                        <v-icon left>close</v-icon>
                        {{ closeButtonText }}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import strings from '../../lang/Strings';

export default {
    name: 'PremiumLock',
    props: {
        isPremium: {
            type: Boolean,
            default: false
        },
        lockTitle: {
            type: String,
            default: null
        },
        lockMessage: {
            type: String,
            default: null
        },
        buttonText: {
            type: String,
            default: null
        },
        modalTitle: {
            type: String,
            default: null
        },
        modalSubtitle: {
            type: String,
            default: null
        },
        upgradeButtonText: {
            type: String,
            default: null
        },
        price: {
            type: String,
            default: '-'
        },
        features: {
            type: Array,
            default: () => []
        },
        msg: {
            type: String,
            default: null
        },
        icon: {
            type: String,
            default: '👑'
        }
    },
    data() {
        return {
            showModal: false,
            strings
        }
    },
    computed: {
        modal() {
            const defaultFeatures = this.idioma === 0 ? [
                'Acesso a todo conteúdo premium',
                'Suporte prioritário 24/7',
                'Dietas e predições ilimitadas',
                'Cadastro de alimentos personalizado',
                'Relatórios detalhados',
                'Atualizações exclusivas'
            ] : (this.idioma === 1 ? [
                'Access to all premium content',
                '24/7 priority support',
                'Unlimited diets and predictions',
                'Custom food registry',
                'Detailed reports',
                'Exclusive updates'
            ] : [
                'Acceso a todo el contenido premium',
                'Soporte prioritario 24/7',
                'Dietas y predicciones ilimitadas',
                'Registro de alimentos personalizado',
                'Informes detallados',
                'Actualizaciones exclusivas'
            ])

            return {
                title: this.modalTitle || this.getString('premium_conteudo_bloqueado_titulo') || 'Upgrade Premium',
                subtitle: this.modalSubtitle || this.getString('premium_conteudo_bloqueado_msg') || 'Desbloqueie todo o potencial da plataforma',
                buttonText: this.upgradeButtonText || this.getString('premium_conteudo_bloqueado_fazer_upgrade') || 'Tornar-se Premium',
                features: this.features.length > 0 ? this.features : defaultFeatures
            }
        },
        lock() {
            return {
                title: this.lockTitle || this.getString('premium_conteudo_bloqueado_titulo') || 'Conteúdo Premium',
                message: this.lockMessage || this.getString('premium_conteudo_bloqueado_msg') || 'Faça upgrade para acessar este conteúdo exclusivo',
                buttonText: this.buttonText || this.getString('premium_conteudo_bloqueado_fazer_upgrade') || 'Desbloquear'
            }
        },
        closeButtonText() {
            return this.idioma === 0 ? 'Talvez depois' : (this.idioma === 1 ? 'Maybe later' : 'Quizás después')
        },
        testeGratisMsg() {
            return this.getString('teste_gratis_sem_compromisso');
        },
        idioma() {
            return parseInt(localStorage.getItem('idioma') || 0);
        }
    },
    methods: {
        handleUpgrade() {
            window.open('/seja-premium', '_blank')
            this.$emit('upgrade-requested')
            this.showModal = false
        },
        show() {
            this.showModal = true
        },
        hide() {
            this.showModal = false
        }
    }
}
</script>

<style scoped>
.premium-modal {
    border-radius: 12px;
    overflow: hidden;
}

.premium-card {
    border-radius: 12px;
    overflow: hidden;
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.2);
}

.premium-header {
    background: linear-gradient(135deg, #2196F3 0%, #673AB7 100%);
    color: white;
    padding: 32px 24px 24px;
    text-align: center;
    position: relative;
}

.premium-header::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: url("data:image/svg+xml,%3Csvg width='100' height='100' viewBox='0 0 100 100' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M11 18c3.866 0 7-3.134 7-7s-3.134-7-7-7-7 3.134-7 7 3.134 7 7 7zm48 25c3.866 0 7-3.134 7-7s-3.134-7-7-7-7 3.134-7 7 3.134 7 7 7zm-43-7c1.657 0 3-1.343 3-3s-1.343-3-3-3-3 1.343-3 3 1.343 3 3 3zm63 31c1.657 0 3-1.343 3-3s-1.343-3-3-3-3 1.343-3 3 1.343 3 3 3zM34 90c1.657 0 3-1.343 3-3s-1.343-3-3-3-3 1.343-3 3 1.343 3 3 3zm56-76c1.657 0 3-1.343 3-3s-1.343-3-3-3-3 1.343-3 3 1.343 3 3 3zM12 86c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm28-65c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm23-11c2.76 0 5-2.24 5-5s-2.24-5-5-5-5 2.24-5 5 2.24 5 5 5zm-6 60c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm29 22c2.76 0 5-2.24 5-5s-2.24-5-5-5-5 2.24-5 5 2.24 5 5 5zM32 63c2.76 0 5-2.24 5-5s-2.24-5-5-5-5 2.24-5 5 2.24 5 5 5zm57-13c2.76 0 5-2.24 5-5s-2.24-5-5-5-5 2.24-5 5 2.24 5 5 5zm-9-21c1.105 0 2-.895 2-2s-.895-2-2-2-2 .895-2 2 .895 2 2 2zM60 91c1.105 0 2-.895 2-2s-.895-2-2-2-2 .895-2 2 .895 2 2 2zM35 41c1.105 0 2-.895 2-2s-.895-2-2-2-2 .895-2 2 .895 2 2 2zM12 60c1.105 0 2-.895 2-2s-.895-2-2-2-2 .895-2 2 .895 2 2 2z' fill='%23ffffff' fill-opacity='0.1' fill-rule='evenodd'/%3E%3C/svg%3E");
    opacity: 0.3;
}

.crown-icon {
    font-size: 40px;
    margin-bottom: 12px;
    filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.2));
}

.premium-title {
    font-size: 24px;
    font-weight: 600;
    margin-bottom: 8px;
    letter-spacing: -0.5px;
}

.premium-subtitle {
    font-size: 14px;
    opacity: 0.9;
    font-weight: 400;
    margin-bottom: 0;
}

.premium-content {
    padding: 24px !important;
}

.features-container {
    margin-bottom: 20px;
}

.feature-item {
    display: flex;
    align-items: center;
    padding: 8px 0;
    border-bottom: 1px solid #e0e0e0;
}

.feature-item:last-child {
    border-bottom: none;
}

.feature-icon {
    margin-right: 12px;
    flex-shrink: 0;
}

.feature-text {
    font-size: 14px;
    color: #424242;
    font-weight: 500;
}

.pricing-section {
    background: linear-gradient(135deg, #f5f5f5 0%, #eeeeee 100%);
    border-radius: 8px;
    padding: 16px;
    text-align: center;
    margin: 20px 0;
    border: 1px solid #e0e0e0;
}

.price-tag {
    display: flex;
    align-items: baseline;
    justify-content: center;
    gap: 4px;
    margin-bottom: 6px;
}

.price-amount {
    font-size: 28px;
    font-weight: 700;
    color: #1976D2;
    background: linear-gradient(135deg, #2196F3 0%, #673AB7 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
}

.price-period {
    font-size: 14px;
    color: #757575;
    font-weight: 500;
}

.price-savings {
    font-size: 12px;
    color: #4CAF50;
    font-weight: 600;
}

.upgrade-button {
    background: linear-gradient(135deg, #4CAF50 0%, #2E7D32 100%) !important;
    color: white !important;
    border-radius: 8px !important;
    height: 48px !important;
    font-weight: 600 !important;
    font-size: 14px !important;
    text-transform: none !important;
    letter-spacing: 0.25px;
    box-shadow: 0 2px 8px rgba(76, 175, 80, 0.3) !important;
    transition: all 0.3s ease !important;
}

.upgrade-button:hover {
    box-shadow: 0 4px 16px rgba(76, 175, 80, 0.4) !important;
}

.guarantee {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
}

.guarantee-text {
    font-size: 12px;
    color: #757575;
}

.premium-actions {
    padding: 0 24px 16px !important;
    justify-content: center;
}

.close-button {
    color: #757575 !important;
    font-weight: 500 !important;
    text-transform: none !important;
}

/* Responsividade */
@media (max-width: 600px) {
    .premium-header {
        padding: 24px 16px 16px;
    }
    
    .premium-title {
        font-size: 20px;
    }
    
    .premium-content {
        padding: 16px !important;
    }
    
    .price-amount {
        font-size: 24px;
    }
    
    .crown-icon {
        font-size: 32px;
    }
}

/* Animações para Vuetify 1.5 */
.premium-card {
    animation: dialog-transition 0.2s ease;
}

@keyframes dialog-transition {
    from {
        opacity: 0;
        transform: scale(0.9);
    }
    to {
        opacity: 1;
        transform: scale(1);
    }
}

.feature-item {
    animation: feature-fade 0.4s ease forwards;
    opacity: 0;
    transform: translateX(-8px);
}

.feature-item:nth-child(1) { animation-delay: 0.1s; }
.feature-item:nth-child(2) { animation-delay: 0.15s; }
.feature-item:nth-child(3) { animation-delay: 0.2s; }
.feature-item:nth-child(4) { animation-delay: 0.25s; }
.feature-item:nth-child(5) { animation-delay: 0.3s; }
.feature-item:nth-child(6) { animation-delay: 0.35s; }

@keyframes feature-fade {
    to {
        opacity: 1;
        transform: translateX(0);
    }
}
</style>